var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook_2_",
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.963,22.048c0.092-3.345-0.525-8.003,0.516-9.593c1.901-2.911,9.496-2.154,9.496-2.154s0-6.612,0-10.303 c-11.982,0-15.904-0.501-20.016,3.675c-3.658,3.715-3.771,11.011-4.072,18.375h-5.872V32.12h5.938 c-0.002,10.504,0.003,22.016,0,31.884c4.462,0,13.954,0,13.954,0v-32.01c0,0,5.173,0,8.042,0 c0.626-3.385,1.236-6.036,2.088-9.947L36.963,22.048L36.963,22.048z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook_1.6bfdb1f7c4f2c886eeee9d84d7fdccc4.svg";
export { ForwardRef as ReactComponent };